import { NgbDateStruct } from '@cmps/ng-bootstrap';

export interface TdBuilderUsageIndividualResult {
    resultSet: string;
    params: string;
    periods: string;
}

export interface TdBuilderUsageIndividualUser {
    userId: number;
    userName: string;
}

export enum TdBuilderUsageIndividualReportPopulationType {
    SuperGroup = '1',
    PeerGroup = '2',
    Individual = '3',
    Role = '4',
    ReptsUnder = '5',
}

export interface TdBuilderUsageIndividualReportSelectionParams {
    populationType: TdBuilderUsageIndividualReportPopulationType;
    populationID: TdBuilderUsageIndividualUser | string;
    defaultPopulationID: TdBuilderUsageIndividualUser | string;
    startDate: NgbDateStruct;
    endDate: NgbDateStruct;
    invalidEndDate: boolean;
    invalidStartDate: boolean;
    pendingData: boolean;
    noData: boolean;
}

export interface TdBuilderUsageIndividualReportResultParams {
    requestUserID: string;
    startDate: string;
    endDate: string;
    populationType: string;
    populationID: string;
    dateRequest: string;
}

export interface TdBuilderUsageIndividualReportResultRow {
    userName: string;
    role: string;
    manager: string;
    superGroup: string;
    generationTimes: Date[];
    dateList: any;
}
